import { RESET_SNACK_BAR } from './types';

export const resetSnackBar = () => (dispatch) => {
    dispatch({
        type: RESET_SNACK_BAR,
        payload: false
    });
};
